import { resource } from '@flexteam/static-resource';
import { EmojiImageSize } from './constants.mjs';

const getSourcePath = (emoji, size = EmojiImageSize.Small) => {
  return resource(
    `/v2/shared/emojis/${size}/${emoji.defaultSkin.unified}.webp`
  );
};
const getSourcePathFromCode = (emojiCode, size = EmojiImageSize.Small) => {
  return resource(`/v2/shared/emojis/${size}/${emojiCode}.webp`);
};
const getEmojiFromEmojiId = (data, emojiId) => {
  return data.emojis[emojiId];
};
const getRandomEmoji = (emojis) => {
  const emojiIds = Object.keys(emojis);
  const pickedEmojiId = emojiIds[Math.floor(Math.random() * emojiIds.length)];
  const pickedEmoji = emojis[pickedEmojiId];
  return pickedEmoji;
};
const getEmojiCodeFromEmoji = (emoji) => {
  const emojiCode = emoji.defaultSkin.unified;
  return emojiCode;
};
const getRandomEmojiCode = (emojis) => {
  const pickedEmoji = getRandomEmoji(emojis);
  return getEmojiCodeFromEmoji(pickedEmoji);
};
const parseFDSCodeToLinearCode = (fdsCode) => {
  return fdsCode.replace(new RegExp("U\\+", "g"), "").toLowerCase();
};
const parseLinearCodeToFDSCode = (linearCode) => {
  return linearCode.split("-").map((code) => `U+${code}`).join("-").toUpperCase();
};

export { getEmojiCodeFromEmoji, getEmojiFromEmojiId, getRandomEmoji, getRandomEmojiCode, getSourcePath, getSourcePathFromCode, parseFDSCodeToLinearCode, parseLinearCodeToFDSCode };
//# sourceMappingURL=utils.mjs.map
